import { NgModule, CUSTOM_ELEMENTS_SCHEMA,NO_ERRORS_SCHEMA } from "@angular/core";
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { AgmCoreModule } from '@agm/core';
import { FileuploadComponent } from './shared-html-components/fileupload/fileupload.component';
import { RecurranceCalculatorComponent } from './shared-html-components/recurrance-calculator/recurrance-calculator.component';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { HttpClient, HttpClientModule} from "@angular/common/http";
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { OfferSearchComponent } from './shared-html-components/offer-search/offer-search.component';
import { ImageModalComponent } from './shared-html-components/image-modal/image-modal.component';
import { CaseSearchComponent } from './shared-html-components/case-search/case-search.component';
import { CustomerAddressControlComponent } from './customers/customer-address-control/customer-address-control.component';
import { DeliveryAddressSelectComponent } from './customers/delivery-address-select/delivery-address-select.component';
import { TransferCaseComponent } from './outbox/transfer-case/transfer-case.component'
import { TransferEkomplettCaseComponent } from './outbox/transfer-ekomplett-case/transfer-ekomplett-case.component';
import { TransferOsCaseComponent  } from './outbox/transfer-os-case/transfer-os-case.component';
import { CustomerSearchComponent } from './shared-html-components/customer-search/customer-search.component';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';
import { InputWithOptionsComponent } from './shared-html-components/input-with-options/input-with-options.component';
import { PdfItemComponent } from './settings/pdf-design/pdf-item/pdf-item.component';
import { ChangeCustomerModalComponent } from './shared-html-components/change-customer-modal/change-customer-modal.component';
import { CurrencyMaskModule } from "ng2-currency-mask";
import { EditorModule } from '@tinymce/tinymce-angular';
import { ConfirmationModalComponent } from './shared/components/confirmation-modal/confirmation-modal.component';
import { CategoryTreeComponent } from './settings/shop/shop-categories/category-tree/category-tree.component';
import { LibraryComponent } from './settings/units/library/library.component';
import { ClearPriceSearchV2Component } from './shared-html-components/clear-price-search-v2/clear-price-search-v2.component';
import { CreateCustomlineComponent } from './shared-html-components/create-customline/create-customline.component';
import { RouterModule } from '@angular/router';
import { PdfViewerModule } from 'ng2-pdf-viewer';
import { AgGridModule } from 'ag-grid-angular';
import { NgxQrcodeStylingModule } from 'ngx-qrcode-styling';
import { CatDropperDirective } from './settings/shop/shop-categories/category-tree/cat-dropper.directive';
import { ItemDropperDirective } from './shared/directives/item-dropper.directive';
import { ImportUnitComponent } from './settings/units/import-unit/import-unit.component';
import { CustomerAddressComponent } from './customers/customer-address/customer-address.component';
import { IconSelectorComponent } from './shared-html-components/icon-selector/icon-selector.component';
import { ImageDropperDirective } from './shared/directives/image-dropper.directive';
import { OpsAndMaintainTreeComponent } from './operations-and-maintenance/ops-and-maintain-tree/ops-and-maintain-tree.component';
import { ImageBranchComponent } from './shared-html-components/image-modal/image-branch/image-branch.component';
import { ImgHeicComponent } from './shared-html-components/img-heic/img-heic.component';
import { NgxDocViewerModule } from 'ngx-doc-viewer';
import { ImageViewerComponent } from './shared-html-components/image-viewer/image-viewer.component';
import { UploadFileComponent } from './shared-html-components/files/upload-file/upload-file.component';
import { DraggableModalDirective } from './shared/directives/draggable-modal.directive';
import { JubloMessengerComponent } from './shared-html-components/jublo-messenger/jublo-messenger.component';
import { SingleMessageComponent } from './shared-html-components/single-message/single-message.component';
import { SingleFileDropDirective } from './shared/directives/single-file-drop.directive';
import { AddressMapComponent } from './shared-html-components/address-map/address-map.component';
import { CompanyCustomerAddressComponent } from './shared-html-components/company-customer-address/company-customer-address.component';
import { BoschContractsComponent } from './special-docs/bosch-contracts/bosch-contracts.component';
import { SingleAddressComponent } from './shared-html-components/single-address/single-address.component';
import { AssetCardComponent } from './assets/asset-card/asset-card.component';
import { AssetInfoComponent } from './assets/asset-info/asset-info.component';
import { AssetCustomFieldComponent } from './assets/asset-custom-field/asset-custom-field.component';
import { CaseTaskCreateComponent } from "./cases/case-task-create/case-task-create.component";
import { ActivityTypeSelectComponent } from './activities/activity-type-select/activity-type-select.component';
import { TinyMCEImageComponent } from './shared-html-components/tiny-mce-image/tiny-mce-image.component';
import { CustomGridFiltersComponent } from './shared-html-components/custom-grid-filters/custom-grid-filters.component';
import { CaseActivityHistoryComponent } from "./shared-html-components/case-activity-history/case-activity-history.component";
import { CaseDocumentsComponent } from "./shared-html-components/case-documents/case-documents.component";
import { CaseFilesComponent } from "./shared-html-components/case-files/case-files.component";
import { CaseFileFoldersComponent } from './shared-html-components/case-files/case-file-folders/case-file-folders.component';
import { CaseMessagesComponent, SafeHtmlPipe } from "./shared-html-components/case-messages/case-messages.component";
import { CaseTasksComponent } from "./shared-html-components/case-tasks/case-tasks.component";
import { CaseOverviewComponent } from "./shared-html-components/case-overview/case-overview.component";
import * as api from './shared/api/apihandler';
import { TaskItemsComponent } from "./task-items/task-items.component";
import { TaskListComponent } from "./task-items/task-list/task-list.component";
import { TaskItemSliderComponent } from "./task-items/task-item-slider/task-item-slider.component";
import { NewTaskSliderComponent } from "./task-items/new-task-slider/new-task-slider.component";
import { CasePartnersV2Component } from './shared-html-components/case-partners-v2/case-partners-v2.component';
import { CustomerCardComponent } from './customers/customer-card/customer-card.component';
import { FileListComponent } from './shared-html-components/case-files/file-list/file-list.component';
import { FileThumbsComponent } from './shared-html-components/case-files/file-thumbs/file-thumbs.component';
import { SafePipe } from "./shared/pipes/safe.pipe";
import { CustomerAddComponent } from './customers/customer-add/customer-add.component';
import { CustomerSearchComponentV2 } from "./customers/customer-search/customer-search.component";
import { CustomerViewComponent } from './customers/customer-view/customer-view.component';
import { CaseTagsComponent } from './shared-html-components/case-tags/case-tags.component';
import { OSSettingsComponent } from "./inbox/os-settings/os-settings.component";
import { MinubaSettingsComponent } from "./inbox/minuba-settings/minuba-settings.component";
import { EkompletSettingsComponent } from "./inbox/ekomplet-settings/ekomplet-settings.component";
import { RuleListComponent } from "./settings/templatemanager/rule-list/rule-list.component";
import { CustomerTagsComponent } from './customers/customer-tags/customer-tags.component';
import { AssetSearchComponent } from './assets/asset-search/asset-search.component';
import { AddressComponent } from './shared/components/address/address.component';
import { ZipComponent } from './shared/components/zip/zip.component';
import { VatComponent } from './shared/components/vat/vat.component';
import { TabListDirective } from './shared/directives/tab-list.directive';
import { ContentAreaDirective } from './shared/directives/content-area.directive';
import { KlarprisPurchasesComponent } from "./shared-html-components/klarpris-purchases/klarpris-purchases.component";
import { CaseAssetComponent } from "./shared-html-components/case-asset/case-asset.component";
import { CustomDatalistComponent } from "./shared-html-components/custom-datalist/custom-datalist.component";
import { BsDatepickerModule } from "ngx-bootstrap/datepicker";
import { OrderByPipe } from "./shared/pipes/JubloPackagesPipe";

export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http, api.jubloApi + 'api/translateShop/', '');
}

@NgModule({
  declarations: [
    FileuploadComponent,
    CatDropperDirective,
    LibraryComponent,
    RecurranceCalculatorComponent,
    OfferSearchComponent,
    ImageModalComponent,
    CaseSearchComponent,
    CustomerAddressControlComponent,
    CustomDatalistComponent,
    TransferCaseComponent,
    TransferEkomplettCaseComponent,
    TransferOsCaseComponent,
    OSSettingsComponent,
    MinubaSettingsComponent,
    EkompletSettingsComponent,
    DeliveryAddressSelectComponent,
    CustomerSearchComponent,
    InputWithOptionsComponent,
    PdfItemComponent,
    ChangeCustomerModalComponent,
    ConfirmationModalComponent,
    CategoryTreeComponent,
    ClearPriceSearchV2Component,
    CreateCustomlineComponent,
    ItemDropperDirective,
    ImportUnitComponent,
    CustomerAddressComponent,
    IconSelectorComponent,
    ImageDropperDirective,
    OpsAndMaintainTreeComponent,
    ImageBranchComponent,
    ImgHeicComponent,
    ImageViewerComponent,
    UploadFileComponent,
    DraggableModalDirective,
    JubloMessengerComponent,
    SingleMessageComponent,
    SingleFileDropDirective,
    AddressMapComponent,
    CompanyCustomerAddressComponent,
    SingleAddressComponent,
    AssetCardComponent,
    AssetInfoComponent,
    AssetCustomFieldComponent,
    CaseTaskCreateComponent,
    BoschContractsComponent,
    ActivityTypeSelectComponent,
    TinyMCEImageComponent,
    CustomGridFiltersComponent,
    CaseActivityHistoryComponent,
    KlarprisPurchasesComponent,
    CaseDocumentsComponent,
    CaseAssetComponent,
    CaseFilesComponent,
    CaseMessagesComponent,
    CaseTasksComponent,
    CaseOverviewComponent,
    SafeHtmlPipe,
    CaseFileFoldersComponent,
    TaskItemsComponent,
    TaskListComponent,
    TaskItemSliderComponent,
    NewTaskSliderComponent,
    CasePartnersV2Component,
    CustomerCardComponent,
    FileListComponent,
    FileThumbsComponent,
    SafePipe,
    CustomerAddComponent,
    CustomerSearchComponentV2,
    CustomerViewComponent,
    CaseTagsComponent,
    RuleListComponent,
    CustomerTagsComponent,
    AssetSearchComponent,
    AddressComponent,
    ZipComponent,
    VatComponent,
    TabListDirective,
    ContentAreaDirective,
    OrderByPipe
  ],
  imports: [
    CommonModule,
    FormsModule,
    HttpClientModule,
    InfiniteScrollModule,
    CurrencyMaskModule,
    RouterModule,
    PdfViewerModule,
    EditorModule,
    NgxDocViewerModule,
    AgGridModule.withComponents(),
    TranslateModule.forChild({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [ HttpClient ]
      },
      isolate: false
    }),
    NgxQrcodeStylingModule,
    AgmCoreModule.forRoot({ apiKey: 'AIzaSyAzWoQOwrMgVrDnCCne4XwQsrHDspEHu1k' }),
    BsDatepickerModule
  ],
  exports: [
    AgmCoreModule,
    ActivityTypeSelectComponent,
    AddressMapComponent,
    AssetCardComponent,
    AssetCustomFieldComponent,
    CustomDatalistComponent,
    CatDropperDirective,
    CommonModule,
    CompanyCustomerAddressComponent,
    CustomerAddressControlComponent,
    CustomerAddressComponent,
    CustomerSearchComponent,
    DeliveryAddressSelectComponent,
    FileuploadComponent,
    FormsModule,
    LibraryComponent,
    OfferSearchComponent,
    RecurranceCalculatorComponent,
    ImageModalComponent,
    CaseSearchComponent,
    TransferCaseComponent,
    TransferEkomplettCaseComponent,
    TransferOsCaseComponent,
    OSSettingsComponent,
    MinubaSettingsComponent,
    EkompletSettingsComponent,
    InputWithOptionsComponent,
    PdfItemComponent,
    ChangeCustomerModalComponent,
    ConfirmationModalComponent,
    CategoryTreeComponent,
    CreateCustomlineComponent,
    ClearPriceSearchV2Component,
    TranslateModule,
    ItemDropperDirective,
    ImportUnitComponent,
    BoschContractsComponent,
    IconSelectorComponent,
    ImageDropperDirective,
    OpsAndMaintainTreeComponent,
    ImageBranchComponent,
    ImgHeicComponent,
    ImageViewerComponent,
    UploadFileComponent,
    DraggableModalDirective,
    JubloMessengerComponent,
    SingleFileDropDirective,
    SingleAddressComponent,
    CaseTaskCreateComponent,
    TinyMCEImageComponent,
    CustomGridFiltersComponent,
    CaseActivityHistoryComponent,
    KlarprisPurchasesComponent,
    CaseDocumentsComponent,
    CaseAssetComponent,
    CaseFilesComponent,
    CaseMessagesComponent,
    CaseTasksComponent,
    CaseOverviewComponent,
    TaskItemsComponent,
    TaskListComponent,
    TaskItemSliderComponent,
    NewTaskSliderComponent,
    SafeHtmlPipe,
    CasePartnersV2Component,
    CustomerCardComponent,
    SafePipe,
    CustomerAddComponent,
    CustomerSearchComponentV2,
    CustomerViewComponent,
    CaseTagsComponent,
    RuleListComponent,
    CustomerTagsComponent,
    AssetSearchComponent,
    AddressComponent,
    ZipComponent,
    VatComponent,
    TabListDirective,
    ContentAreaDirective,
    BsDatepickerModule,
    OrderByPipe
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA]
})
export class SharedModule{ }


